import { render, staticRenderFns } from "./AdministrativeInformation.vue?vue&type=template&id=4482eb60&scoped=true"
import script from "./AdministrativeInformation.vue?vue&type=script&lang=js"
export * from "./AdministrativeInformation.vue?vue&type=script&lang=js"
import style0 from "./AdministrativeInformation.vue?vue&type=style&index=0&id=4482eb60&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4482eb60",
  null
  
)

export default component.exports